export function useInitialLoadState(status) {
  const initialResolved = ref(false);

  watch(() => toValue(status), value => {
    if (value === 'success' || value === 'error') {
      initialResolved.value = true;
    }
  }, {immediate: true, flush: 'sync'});

  return {
    initialResolved: readonly(initialResolved),
    initialLoading: computed(() => !initialResolved.value)
  };
}
